import {
  parseAskUserToolInput,
  parseAskUserToolOutput,
  type AskUserToolPart,
} from '../chat-ask-user-flow';
import { useChatToolInteraction } from '../chat-tool-interaction';
import { AskUserWidget } from './AskUserWidget';

type ChatAskUserToolProps = {
  toolPart: AskUserToolPart;
};

export function ChatAskUserTool({ toolPart }: ChatAskUserToolProps) {
  const {
    isAskUserSubmitting,
    retryAskUserContinuation,
    submitAskUserOutput,
    toolContinuationError,
  } = useChatToolInteraction();

  const input = parseAskUserToolInput(toolPart.input);
  const output = parseAskUserToolOutput(toolPart.output);

  if (!input) {
    return null;
  }

  const hasContinuationError = toolContinuationError?.toolCallId === toolPart.toolCallId;

  const widgetState = toolPart.state === 'input-streaming'
    || toolPart.state === 'input-available'
    || toolPart.state === 'output-available'
    || toolPart.state === 'output-error'
    ? toolPart.state
    : 'input-available';

  return (
    <AskUserWidget
      allowFreeText={input.allowFreeText}
      allowMultiple={input.allowMultiple}
      hasContinuationError={hasContinuationError}
      isSubmitting={isAskUserSubmitting && toolPart.state === 'input-available'}
      options={input.options}
      output={output}
      question={input.question}
      state={widgetState}
      onRetry={retryAskUserContinuation}
      onSubmit={(nextOutput) => {
        submitAskUserOutput({
          output: nextOutput,
          toolCallId: toolPart.toolCallId,
        });
      }}
    />
  );
}
